<template>
  <v-container fluid>
    <v-card elevation="0" class="rounded-xl">
      <v-card-title> Order Detail </v-card-title>
      <v-card-text>
        <v-container fluid class="d-flex white rounded-xl" style="gap: 5px"
          ><order-card :order="order" @handle-event="openDialog"></order-card
          ><order-options
            class="d-none d-sm-none d-md-none d-lg-block"
            v-model="order"
            @delete-event="$router.go(-1)"
          ></order-options></v-container
      ></v-card-text>
    </v-card>
    <v-dialog v-model="dialog" max-width="350">
      <order-options
        show-id
        v-model="order"
        @delete-event="$router.go(-1)"
      ></order-options>
    </v-dialog>
  </v-container>
</template>
<script>
import backendService from "../services/backend-service.js";
import generalMixin from "@/js/general-mixin";
import OrderCard from "@/components/OrderCard.vue";
import OrderOptions from "@/components/OrderOptions.vue";
export default {
  name: "OrderDetail",
  data() {
    return {
      order: {},
      dialog: false,
    };
  },
  mixins: [generalMixin],
  components: { "order-card": OrderCard, "order-options": OrderOptions },
  created: function () {
    this.getOrder();
  },
  computed: {},
  methods: {
    getProductPictureUrlById(imageId) {
      return backendService.getProductPictureUrlById(imageId);
    },
    getOrder() {
      backendService.getOrderById(this.$route.params.id).then((response) => {
        this.order = response.data;
      });
    },
    print() {
      this.printReceipt(this.order);
    },
    openDialog() {
      this.dialog = true;
    },
  },
};
</script>
<style scoped>
.image-preview {
  object-fit: contain;
  image-rendering: smooth;
  width: 100px;
  height: 100px;
}
</style>
